import { createEmitter } from "ts_utils";
import { SubRemover } from "../utilities/SubRemover";
import { Templates } from "./Templates";
import { confirmationDg } from "./templates/confirmationTemplates";

export class ConfirmationBox {
	private _ui:HTMLDivElement;
	private _resolve:(confirmed:boolean) => void;
	
	private _sr:SubRemover = new SubRemover();
	
	public get select() { return this._selectionEemitter.event; }
	private _selectionEemitter = createEmitter<boolean>();
	
	/**displays a message for the length of time requested
	 * @param message - the message to display
	 * @param msDuration - the duration, in milliseconds*/
	constructor(msg:string){
		this._ui = Templates.createDiv(confirmationDg);
		this._ui.querySelector(".cfm-message").innerHTML = msg;
		document.body.append(this._ui);
		
		let okayBtn:HTMLButtonElement = this._ui.querySelector(
			'.cfm-confirm-ok');
		let cancelBtn:HTMLButtonElement = this._ui.querySelector(
			'.cfm-confirm-cancel');
		
		this._sr.add(okayBtn, "click", this._onConfirmClick);
		this._sr.add(cancelBtn, "click", this._onCancelClick);
	}
	
	public awaitConfirmation():Promise<boolean> {
		return new Promise<boolean>((resolve, reject) => {
			this._resolve = resolve;
		});
	}
	
	public setWidth(widthStr:string){
		this._ui.style.width = widthStr;
	}
	
	private _onConfirmClick = (e:MouseEvent):void => {
		this._finish(true);
	}
	
	private _onCancelClick = (e:MouseEvent):void => {
		this._finish(false);
	}
	
	private _finish(confirmed:boolean):void {
		this._sr.removeAllSubs();
		this._selectionEemitter.emit(confirmed);
		if (this._resolve != null){
			this._resolve(confirmed);
		}
		this._ui.remove();
	}
}